// extracted by mini-css-extract-plugin
export default {"toggle":"BookStyleSelector_toggle__1sAIv"};